exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputBox[data-v-09c79c5d]{width:273px}", ""]);

// exports
